import { css } from '@emotion/react'

const dropdownContainer = css`
  & > * {
    width: 100%;
  }
`

export const styles = {
  dropdownContainer,
}
